// ============================================
// components/porchlight/PorchlightControls.js
// ============================================
import React from 'react';
import { Box, Typography, Link, Paper, Stack } from '@mui/material';

const PorchlightControls = ({ isActive, isPending, onAdjustSettings }) => {
  return (
    <Box sx={{ mt: 1, px: 2, width: '100%', maxWidth: 420, mx: 'auto', position: 'relative', zIndex: 1 }}>
      <Paper elevation={0} variant="glass" sx={{
        px: 3,
        py: 2.25,
        textAlign: 'center',
        // Option B: dark tinted glass (frosted, readable, lets gold glow show through)
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(15,23,42,0.18)',
        border: '1px solid rgba(255,255,255,0.12)'
      }}>
        <Stack spacing={1} alignItems="center">
          <Typography
            variant="subtitle1"
            component="p"
            sx={{ color: isActive ? 'primary.contrastText' : 'primary.main', fontWeight: 600 }}
          >
            {isActive ? 'Your porchlight is on.' : 'Your porchlight is off.'}
          </Typography>
          <Typography variant="body2" sx={{ color: isActive ? 'primary.contrastText' : 'text.primary' }}>
            {isActive
              ? 'You’re visible to selected friends for the chosen duration.'
              : 'Turn it on to let friends know you’re available.'}
          </Typography>
          {isActive && !isPending && (
            <Link
              component="button"
              onClick={onAdjustSettings}
              underline="always"
              data-testid="adjust-settings-btn"
              sx={{ fontSize: '0.95rem', color: isActive ? 'primary.contrastText' : 'text.primary', textUnderlineOffset: '2px', fontWeight: 600 }}
            >
              Adjust settings
            </Link>
          )}
        </Stack>
      </Paper>
    </Box>
  );
};

export default PorchlightControls;